import { atom, useAtom } from 'jotai';
import { selectAtom } from 'jotai/utils';
import styled from 'styled-components';
import { AdvancedMarker, Map } from '@vis.gl/react-google-maps';

import { filterdListAtom } from '@/components/devices/Filter';
import MapMarker from './MapMarker';

import type { Device } from '@/@types/device';

export const Balloon = styled('div')`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%) translate(0, -16px);

  width: max-content;
  border-radius: 12px;
  padding: 16px;
  color: white;
  font-size: 16px;

  &.online {
    background-color: #536BFF;
    &::after {
      border-top-color: #536BFF;
    }
  }
  &.offline {
    background-color: #787878;
    &::after {
      border-top-color: #787878;
    }
  }
  &.alarm {
    background-color: #FF3B30;
    &::after {
      border-top-color: #FF3B30;
    }
  }

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);

    border-top: 16px solid white;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 0px solid transparent;
  }
`;

export const selectedDeviceAtom = atom<Device>();
export const selectedDeviceSafeAtom = selectAtom<Device, Device>(selectedDeviceAtom, (next, prev) => next ?? prev);

export default function MapView() {
  const [selectedDevice, setSelectedDevice] = useAtom(selectedDeviceAtom);
  const [filterdList] = useAtom(filterdListAtom);

  function onMapClick() {
    setSelectedDevice(null);
  }

  return (
    <>
      <Map
        mapId="72bde87919bda695"
        defaultCenter={{ lat: 37.483333, lng: 127.123155 }}
        defaultZoom={12}
        gestureHandling="greedy"
        disableDefaultUI
        clickableIcons={false}
        onClick={onMapClick}
      >
        {filterdList &&
          filterdList
            .filter((device) => device.data.latitude)
            .map((device) => <MapMarker key={device.serialNumber} device={device} />)}
      </Map>
      {selectedDevice && selectedDevice.data.latitude && (
        <AdvancedMarker
          position={{ lat: selectedDevice.data.latitude, lng: selectedDevice.data.longitude }}
          zIndex={999}
        >
          <div style={{ width: 64, height: 64 }} />
          <Balloon className={selectedDevice.status}>
            {selectedDevice.name}
            <br />
            {selectedDevice.serialNumber}
          </Balloon>
        </AdvancedMarker>
      )}
    </>
  );
}
